import { put } from 'redux-saga/effects';

import api from './../api';
import { eventFetchSuccess, eventFetchFail, eventsFetchSuccess, eventsFetchFail, partnerPortalSettingsFetchSuccess, partnerPortalSettingsFetchFail, fetchCart } from '../actions';

export function* eventFetchSaga(action) {
  try {

    const { eventID } = action;

    const response = yield api.events.getEvent(eventID);

    if (!response.data.data.event) {
      const customError = {code: 0, title: 'General error', details: 'There was an error when trying to fetch event'};
      throw customError;
    }
    yield put(eventFetchSuccess(response.data.data.event));
    yield put(fetchCart(eventID));
  } catch (error) {
    yield put(eventFetchFail(error));
  }
}


export function* eventsFetchSaga(action) {
  try {

    // Fetch events
    const response = yield api.events.getEvents(action.userID);

    // Check that response contains events
    if (!response.data.data.events) {
      const customError = {code: 0, title: 'General error', details: 'There was an error when trying to fetch events'};
      throw customError;
    }

    yield put(eventsFetchSuccess(response.data.data.events));

  } catch (response) {
    yield put(eventsFetchFail(response.error));
  }
}

export function* partnerPortalSettingsFetchSaga(action) {
  try {

    const { eventID } = action;

    const response = yield api.events.getPartnerPortalSettings(eventID);
    if (!response.data.data.partnerPortals) {
      const customError = {code: 0, title: 'General error', details: 'There was an error when trying to fetch partner portal settings'};
      throw customError;
    }
    yield put(partnerPortalSettingsFetchSuccess(response.data.data.partnerPortals));

  } catch (error) {
    yield put(partnerPortalSettingsFetchFail(error));
  }
}